import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { usersAPI } from '../api';
import { updatePermissions } from './authSlice';
import { CLIENT_NOTS, getClientNotify } from './notifySlice';
import { updateAvailableUsers } from './settingSlice';;


const initialState = {
    list: [],
};

export const fetchUsers = createAsyncThunk('user/fetchUsers', async (_, thunkAPI) => {
    const data = await usersAPI.get();//@ts-ignore
    if (data.isOkay) {
        thunkAPI.dispatch(setUsersData(data.users));
    } else {
        console.log(data)
    }
    return data.isOkay;
});

export const createUser = createAsyncThunk('user/create', async ({userData, resetFunc, unlockButton}, thunkAPI) => {
    const data = await usersAPI.create(userData);
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.CREATE_USER}));
    if (data.isOkay) {
        thunkAPI.dispatch(addUser(data.user));
        thunkAPI.dispatch(updateAvailableUsers(data.availableUsers));
        data.authPerms && thunkAPI.dispatch(updatePermissions(data.authPerms));
        resetFunc();
    } else {
        unlockButton();
        console.log(data)
    }
    return data.isOkay;
});

export const editUser = createAsyncThunk('user/edit', async ({userData, resetFunc}, thunkAPI) => {
    const data = await usersAPI.edit(userData);
    thunkAPI.dispatch(getClientNotify({data, action: CLIENT_NOTS.EDIT_USER}));
    if (data.isOkay) {
        thunkAPI.dispatch(updateUser(data.user));
        resetFunc();
    } else {
        console.log(data)
    }
    return data.isOkay;
});

export const deleteUser = createAsyncThunk('user/delete', async ({userId, deleted}, thunkAPI) => {
    const data = await usersAPI.delete(userId, deleted);
    thunkAPI.dispatch(getClientNotify({data, action: deleted ? CLIENT_NOTS.DELETE_USER : CLIENT_NOTS.RECOVERY_USER}));
    if (data.isOkay) {
        thunkAPI.dispatch(setDeletingUser({_id: data.user._id, deleted}));
    } else {
        console.log(data)
    }
    return data.isOkay;
});

const userSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setUsersData(state, {payload}) {
            state.list = payload;
        },
        clearUsersState(state) {
            state.list = [];
        },
        addUser(state, {payload}) {
            state.list = [...state.list, payload];
        },
        updateUser(state, {payload}) {
            state.list = state.list.map(user => user._id === payload._id ? payload : user);
        },
        setDeletingUser(state, {payload}) {
            state.list = state.list.map(user => user._id !== payload._id ? user : ({...user, deleted: payload.deleted}));
        },
        dropUserDocument(state, {payload}) {
            state.list = state.list.map(u => u._id !== payload.userId ? u : (
                {
                ...u,
                personalData: {
                    ...u.personalData,
                    documents: u.personalData.documents.filter(docName => docName !== payload.fileName)
                }
            }))
        }

    },
    extraReducers: (builder) => {
        
    },
});

export const { setUsersData, clearUsersState, updateUser, addUser, setDeletingUser, dropUserDocument } = userSlice.actions;

export default userSlice.reducer;
